import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { FolderOpen } from '@phosphor-icons/react';
import { ChartColor } from '@t-one-internal/design-system';

interface CategoryRow {
    categoryName: string;
    totalEnrollments: number;
    completedCount: number;
}

interface OrgCompletionByCategoryWidgetProps {
    data?: CategoryRow[] | null;
    loading?: boolean;
    error?: string;
}

export const OrgCompletionByCategoryWidget: React.FC<OrgCompletionByCategoryWidgetProps> = ({ data, loading, error }) => {
    const rows = Array.isArray(data) ? data : [];

    const chartData = rows.map(r => ({
        name: (r.categoryName || '').length > 15 ? r.categoryName.slice(0, 15) + '...' : r.categoryName,
        total: Number(r.totalEnrollments) || 0,
        completed: Number(r.completedCount) || 0,
    }));

    return (
        <div className="flex flex-col h-full p-5">
<div className="flex-1">
                {loading ? (
                    <div className="flex items-center justify-center h-full">
                        <div className="w-6 h-6 border-3 border-gray-200 border-t-primary rounded-full animate-spin" />
                    </div>
                ) : error ? (
                    <div className="flex items-center justify-center h-full text-red-500 text-sm">{error}</div>
                ) : rows.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-full text-gray-400 gap-2">
                        <FolderOpen className="w-8 h-8" />
                        <span className="text-sm">No category data</span>
                    </div>
                ) : (
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData} margin={{ left: 0, right: 20, top: 5, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" vertical={false} />
                            <XAxis dataKey="name" tick={{ fontSize: 11 }} />
                            <YAxis tick={{ fontSize: 11 }} />
                            <Tooltip />
                            <Legend wrapperStyle={{ fontSize: 11 }} />
                            <Bar dataKey="total" name="Total" fill={ChartColor.sky} radius={[4, 4, 0, 0]} barSize={20} />
                            <Bar dataKey="completed" name="Completed" fill={ChartColor.blue} radius={[4, 4, 0, 0]} barSize={20} />
                        </BarChart>
                    </ResponsiveContainer>
                )}
            </div>
        </div>
    );
};
